import { render, staticRenderFns } from "./v-fade.vue?vue&type=template&id=5089b57a&scoped=true&"
import script from "./v-fade.vue?vue&type=script&lang=js&"
export * from "./v-fade.vue?vue&type=script&lang=js&"
import style0 from "./v-fade.vue?vue&type=style&index=0&id=5089b57a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089b57a",
  null
  
)

export default component.exports